
export function getString (key) {
  const value = localStorage.getItem(key)
  if (value) {
    return value
  }
  return null
}

export function setString (key, value) {
  localStorage.setItem(key, value)
}

const KEY = 'ingame_language'

export const LanguageType = {
  zh_CN: 'zh_CN',
  en_US: 'en_US'
}

export function setLocaleLanguage (value) {
  setString(KEY, value)
}

export function getLocaleLanguage () {
  // console.log('KEY==',KEY)
  return getString(KEY)
}

Object.assign(window, {
  __setLanguage: function (value) {
    setLocaleLanguage(value)
    window.location.reload()
  }
})



// WEBPACK FOOTER //
// ./src/utils/language.js